import React from 'react';
import PropTypes from 'prop-types';

const Name = ({value, onChange = () => {}, isError = false}) => (
    <div id="row_fullname" className="personal-info__item">
        <div className="personal-info__lbl">Your name:*</div>
        <div className="personal-info__value">
            <input className={`${isError ? `form-error` : ``}`} value={value} onChange={(event) => {onChange(event.target.value)}} type="text" id="name" name="name" placeholder="e.g. Jonh Smith" />
            {isError &&
            <div className="validation_error err-popup" id="error_name">
                Enter your valid name like 'John Smith'
            </div>
            }
        </div>
    </div>
)

Name.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    isError: PropTypes.bool,
};

export default Name
